/* --------------------------------------------------------------------------------------
   xwSegmented.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { useRef, useEffect } from "preact/hooks"
import { MFDApp } from "../../constants/MFDApp.const"

const XwSegmented = props => {
    const elementRef = useRef(null)
    useEffect(() => {
        $(elementRef.current).xrxsegmentedcontrol(getOptions(props))
        switchIconAndText()
        return () => $(elementRef.current).xrxsegmentedcontrol("destroy")
    }, [])
    return <select ref={elementRef}>
        {props.children}
    </select>
}

const getOptions = props => ({
    ...props,
    theme: props.theme || MFDApp.theme,
    select: (event, ui) => props.onSelect(ui.item),
    children: undefined
})

const switchIconAndText = () => {
    $("li").each(function () {
        let $this = $(this)
        let $span = $this.find("span");

        if ($span.length) {
            const text = $this.text().trim();
            $this.empty().append(text).append($span);
            $this.css("padding-left", "16px");
            $span.css("position", "relative");
            $span.css("left", "8px");
            $span.css("top", screen.width < 801? "8px" : "9px");           
        }
    });
}

export default XwSegmented